import React, { useEffect, useState } from "react";
import { Modal, Skeleton, Tabs, Tooltip } from "antd";
import mapprTrackerData from "../../../helper/constant/mapprTrackerData.json";
import { objectValidation } from "../../../helper/validation";
import { LazyLoadImage } from "react-lazy-load-image-component";
import TestInstruction from "../../../components/testInstruction/testInstruction";
import { getStudentData, setLocalStorage } from "../../../helper/localStorage";
import { LaunchTestContext } from "../../../store/launchTestStore";
import { HelperContext } from "../../../store/helperStore";
import {
  startDigitMemorySpanTest,
  startDigitReverseSpanTest,
} from "../../../container/tDigitMemorySpan/startDigitMemorySpan";
import { useHistory } from "react-router-dom";
import { getFullScreen, cancelFullScreen } from "../../../helper/fullscreen";
import { AnswerContext } from "../../../store/answerStore";
import { startReverseNumberSequenceTest } from "../../../container/tReverseNumberSequence/startReverseNumberSequence";
import { startRememberTheNumberTest } from "../../../container/tRememberTheNumber/startRememberTheNumberSequence";
import { startPatternPairAssociationTest } from "../../../container/tPatternPairAssociation/startPatternPairAssociation";
import { fetchTestApi } from "../../../api/fetchTest";
import { fetchAssignedTest } from "../../../api/fetchAssignedTest";
import { FetchAssignedTestContext } from "../../../store/assignedTestStore";
import { RecorderContext } from "../../../store/recorderStore";
import { NoAnyTestAvail } from "../startTest/noAnyTestAvail";
import defaultImage from "../../../assets/img/startTest/cardImg/ic_190425225010.svg";

const { TabPane } = Tabs;

const level = JSON.parse(localStorage.getItem("gradeId"));
const skeletonLoader = () => {
  return (
    <div className="categories-tests skeleton-loader">
      <Skeleton className="card" active />
      <Skeleton className="card" active />
    </div>
  );
};

function MapprTracker() {
  setLocalStorage("isScreenReloaded", false);
  const {assignedTestC, dispatchAssignedTest} = FetchAssignedTestContext();
  // const { recorderC, dispatchRecorder } = RecorderContext();

  const [instVisible, setInstVisible] = useState();
  const [testData, setTestData] = useState([]);
  const history = useHistory();

  const { launchTestC, dispatchLaunchTest } = LaunchTestContext();
  const { helperC, dispatchHelper } = HelperContext();
  const { dispatchAnswer } = AnswerContext();
  const [activeColor, setActiveColor] = useState(mapprTrackerData.data[0].group_color);

  const { assignedTestData, loader, err } = assignedTestC;

  const { launchTestData } = launchTestC;
  const handleLaunchTest = () => {
    dispatchHelper({
      type: "TEST_TYPE",
      payload: "",
    });

    history.push({
      pathname: `/amaze_test`,
      state: { routeFrom: "mappr_tracker" },
    });
    getFullScreen();
  };
  
  const handleCardClick = (testData) => {
    setInstVisible(true);
    const constGradeId = getStudentData().grade_id;
    
    switch (testData.test_format) {
      case "digit_span":
        startDigitMemorySpanTest(testData.test_id, constGradeId, dispatchLaunchTest, dispatchHelper);
        break;
      case "reverse_number":
        startReverseNumberSequenceTest(testData.test_id, constGradeId, dispatchLaunchTest, dispatchHelper);
        break;
      case "pattern_memory":
        startPatternPairAssociationTest(testData.test_id, constGradeId, dispatchLaunchTest, dispatchHelper);
        break;
      case "memory_tap":
        startRememberTheNumberTest(testData.test_id, constGradeId, dispatchLaunchTest, dispatchHelper);
        break;
      default:
        fetchTestApi(testData.test_id, constGradeId, dispatchLaunchTest, dispatchHelper);
        break;
    }

    // if (testData.test_name === "DIGIT REVERSE SPAN") {
    //   startDigitReverseSpanTest(
    //     testData.test_id,
    //     constGradeId, // variable grade id
    //     dispatchLaunchTest,
    //     dispatchHelper
    //   );
    // } else if(testData.test_name === "REVERSE NUMBER SEQUENCE") {
    //   startReverseNumberSequenceTest(
    //     testData.test_id,
    //     constGradeId,
    //     dispatchLaunchTest,
    //     dispatchHelper
    //   )
    // } else if (testData.test_name === 'REMEMBER THE NUMBERS') {
    //   startRememberTheNumberTest(
    //     testData.test_id,
    //     constGradeId,
    //     dispatchLaunchTest,
    //     dispatchHelper
    //   )
    // } else if (testData.test_name === 'PATTERN PAIR ASSOCIATION') {
    //   startPatternPairAssociationTest(
    //     testData.test_id,
    //     constGradeId,
    //     dispatchLaunchTest,
    //     dispatchHelper
    //   );
    // } else {
    //   fetchTestApi(
    //     testData.test_id,
    //     constGradeId, // variable grade id
    //     dispatchLaunchTest,
    //     dispatchHelper //for storing first question id
    //   );
    // }
    // setInstVisible(true);
  };

  const getTest = (test) => {
    return (
      objectValidation(test) &&
      test.test.map((data, index) => {
        return (
          <Card
            key={index}
            handleCardClick={() => handleCardClick(data)}
            data={data}
            group_color={test.group_color + '25'}
          ></Card>
        );
      })
    );
  };

  useEffect(() => {
    if (!loader && !err) {
      const audioTest = assignedTestData && assignedTestData.audio.data;
      const nonAudioTest = assignedTestData && assignedTestData.non_audio.data;
      const testArray = [...audioTest, ...nonAudioTest];
      const regionData = testArray.filter(item => item.region === "US" || item.region === "" || item.region === null || !item.region);

      setTestData(regionData);
      mapprTrackerData.data.forEach((group) => group.test = []);
      regionData.forEach((test) => {
        if (test.test_name.match(/\b(MEMORY RECALL|SOUND VOCABULARY|VERBAL MEMORY|DUAL N-BACK 1|FACE-NAME MIX|SPEED IMAGE RECALL|Digit Memory Span|Remember the Pictures|Words in the List|Follow the Target|Facial Emotion Detect|Pictures Words Numbers|REMOTE ASSOCIATE|REVERSE MEMORY SPAN)\b/)) {
            mapprTrackerData.data[0].test.push(test);
        }
    
        if (test.test_name.match(/\b(ANTONYMS|READING COMPREHENSION|LISTENING|SOUND VOCABULARY|VERBAL MEMORY|SOUND MATCHING|WORD SOUNDS|SOUND DIFFERENTIATION|TEXT MATCHING|SOUND VOCABULARY|Remember the Words|Words in the List)\b/)) {
            mapprTrackerData.data[1].test.push(test);
        }
    
        if (test.test_name.match(/\b(NUMERICAL REASONING|NUMBER SEQUENCE|MATRIX LOGIC|SPATIAL ROTATION|IMAGE IDENTIFY|Remember the Numbers|Pattern Pair Association|Reverse Number Sequence|MATHEMATICS|REVERSE MEMORY SPAN)\b/)) {
            mapprTrackerData.data[2].test.push(test);
        }
    
        if (test.test_name.match(/\b(REVERSE MEMORY SPAN)\b/)) {
            mapprTrackerData.data[3].test.push(test);
        }
    
        if (test.test_name === 'REVERSE NUMBER SEQUENCE') {
            mapprTrackerData.data.forEach((item) => item.test.push(test));
        }
    });
      // console.log(testArray)
      // console.log(audioTest, nonAudioTest);
    }
  }, [assignedTestData, loader, err]);

  useEffect(() => {
    const isAssignedTestAvailable = objectValidation(
      assignedTestC.assignedTestData
    );

    if (!isAssignedTestAvailable) {
      fetchAssignedTest(level, dispatchAssignedTest);
    }
    cancelFullScreen();
    dispatchLaunchTest({ type: "RESET" });
    dispatchAnswer({ type: "RESET_ANSWER" });
    dispatchHelper({ type: "OFF_HEIGHT", payload: 0 });
    dispatchHelper({ type: "TEST_TYPE", payload: "" });
    dispatchHelper({ type: "FACE_DATA", payload: false });
    dispatchHelper({ type: "RUNNING_QUES_ID", payload: "" });
    dispatchHelper({ type: "RESET_AUDIO_STAT" });
  }, []);
  return (
    <>
      <Tabs
        className="dashBoard-tab"
        defaultActiveKey={"1"}
        onChange={(key) => setActiveColor(mapprTrackerData.data[parseInt(key, 10) - 1].group_color)}
        style={{ '--text-color': activeColor }}
      >
        {mapprTrackerData.data.map((item, index) => (
          <TabPane tab={<div className="custom-color">{item.group_name}</div>} key={(index + 1).toString()}>
            <div className="test-list start-test">
              {assignedTestC.loader || assignedTestC.err ? (
                skeletonLoader()
              ) : !assignedTestC.isAudioTestAssign ||
                !assignedTestC.isTestAvailable ? (
                <NoAnyTestAvail />
              ) : (
                <>
                {getTest(item)}
                  {/* {testData.map} */}
                </>
              )}
            </div>
          </TabPane>
        ))}
      </Tabs>

      <Modal
        style={{ top: 12, maxWidth: "1082px" }}
        width="98%"
        visible={instVisible}
        className="sml-modal dash-inst"
        onCancel={() => setInstVisible(false)}
        footer={null}
      >
        <TestInstruction
          launchTestData={launchTestData}
          handleBtn1={() => handleLaunchTest()}
          btnName1="Start Test"
        ></TestInstruction>
      </Modal>
    </>
  );
}

export default MapprTracker;

const Card = (props) => {
  const imgExists = (testId) => {
    try {
      require(`../../../assets/img/startTest/cardImg/ic_${testId}.svg`);
      return true;
    } catch (error) {
      return false;
    }
  };

  const getImageSource = () => {
    const { data } = props;
    const { test_id } = data;

    if (test_id && imgExists(test_id)) {
      return require(`../../../assets/img/startTest/cardImg/ic_${test_id}.svg`);
    } else {
      return defaultImage;
    }
  };

  return (
    <Tooltip title={props.data.intro3}>
      <div
        className="dash-test-card"
        style={{
          background: props.group_color,
        }}
        onClick={props.handleCardClick}
      >
        <div className="dash-test-card-img">
          <LazyLoadImage
            // placeholderSrc={placeholderIcon}
            alt=""
            // effect="blur"
            src={getImageSource()}
          />
        </div>
        <div className="card-title">
          <h3 className="">{props.data.test_name.toUpperCase()}</h3>
        </div>
      </div>
    </Tooltip>
  );
};
